import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import { __decorate } from "tslib";
import { Component, provide } from 'intact-vue-next';
import template from './form.vdt';
import { useRecordParent } from '../../hooks/useRecordComponent';
import { addMethod } from './methods';
import { bind } from '../utils';
import { useConfigContext } from '../config';
var typeDefs = {
  labelWidth: [String, Number],
  layout: ['horizontal', 'vertical', 'inline'],
  starOnRequired: Boolean,
  size: ['default', 'small', 'mini']
};
var defaults = function defaults() {
  return {
    layout: 'horizontal',
    size: 'default'
  };
};
export var FORM = 'Form';
export var RECORD_KEY = 'FormRecord';
export var Form = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Form, _Component);
  function Form() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.items = useRecordParent(RECORD_KEY);
    _this.config = useConfigContext();
    return _this;
  }
  var _proto = Form.prototype;
  _proto.init = function init() {
    provide(FORM, this);
  };
  _proto.validate = function validate() {
    var _context2;
    return _Promise.all(_mapInstanceProperty(_context2 = this.items).call(_context2, function (item) {
      return item.validate();
    })).then(function (values) {
      return values.every(function (value) {
        return value;
      });
    });
  };
  _proto.getFirstInvalidFormItem = function getFirstInvalidFormItem() {
    var _context3;
    return _findInstanceProperty(_context3 = this.items).call(_context3, function (item) {
      if (!item.isValid()) {
        return item;
      }
    });
  };
  _proto.submit = function submit(e) {
    var _this2 = this;
    this.validate().then(function (valid) {
      if (valid) {
        _this2.trigger('submit', e);
      }
    });
  };
  _proto.reset = function reset() {
    this.items.forEach(function (item) {
      return item.reset();
    });
  };
  _proto.onSubmit = function onSubmit(e) {
    e.preventDefault();
    this.submit(e);
  };
  return Form;
}(Component);
Form.template = template;
Form.typeDefs = typeDefs;
Form.defaults = defaults;
Form.addMethod = addMethod;
__decorate([bind], Form.prototype, "onSubmit", null);